const indexData = [
  { icon: 'ri-movie-2-line', title: '热门电影', count: '12,860部', color: 'text-accent-400', bg: 'bg-accent-500/10', border: 'border-accent-500/20' },
  { icon: 'ri-tv-2-line', title: '电视剧', count: '8,520部', color: 'text-primary-400', bg: 'bg-primary-500/10', border: 'border-primary-500/20' },
  { icon: 'ri-live-line', title: '综艺节目', count: '3,240部', color: 'text-secondary-400', bg: 'bg-secondary-500/10', border: 'border-secondary-500/20' },
  { icon: 'ri-ghost-line', title: '动漫番剧', count: '5,680部', color: 'text-accent-400', bg: 'bg-accent-500/10', border: 'border-accent-500/20' },
  { icon: 'ri-slideshow-2-line', title: '纪录片', count: '2,150部', color: 'text-primary-400', bg: 'bg-primary-500/10', border: 'border-primary-500/20' },
  { icon: 'ri-user-star-line', title: '高分推荐', count: '1,960部', color: 'text-secondary-400', bg: 'bg-secondary-500/10', border: 'border-secondary-500/20' },
  { icon: 'ri-fire-line', title: '热播榜单', count: 'TOP 100', color: 'text-accent-400', bg: 'bg-accent-500/10', border: 'border-accent-500/20' },
  { icon: 'ri-calendar-check-line', title: '即将上线', count: '320部', color: 'text-primary-400', bg: 'bg-primary-500/10', border: 'border-primary-500/20' },
  { icon: 'ri-heart-line', title: '我的片单', count: '个人收藏', color: 'text-secondary-400', bg: 'bg-secondary-500/10', border: 'border-secondary-500/20' },
];

export default function IndexSection() {
  return (
    <section id="index" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">影视索引</h2>
          <p className="text-foreground-400 text-sm">全品类影视内容导航，快速找到你想看的</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4 max-w-[900px] mx-auto">
          {indexData.map((item, i) => (
            <a key={i} href="#ranking" className={`group flex items-center gap-3 p-4 rounded-xl ${item.bg} border ${item.border} hover:scale-[1.02] transition-all duration-200 cursor-pointer`}>
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${item.bg} border ${item.border}`}>
                <i className={`${item.icon} text-lg ${item.color}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className={`font-bold text-sm ${item.color}`}>{item.title}</div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.count}</div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-500 group-hover:text-foreground-200 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}